import './Masthead.css'

const links = [
    { href: '#about', label: 'About' },
    { href: '#skills', label: 'Toolbox' },
    { href: '#work', label: 'Work' },
    { href: '#contact', label: 'Contact' }
];

export default function Masthead() {
    return (
        <header className='container masthead'>
            <div className='masthead-bar'>
                <span>Vol. I — Portfolio Edition</span>
                <nav className='masthead-nav'>
                    {links.map(link => <a key={link.href} href={link.href}>{link.label}</a>)}
                </nav>
            </div>
        </header>
    )
}
